import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeUrl } from 'src/app/pipes/safe-url.pipe';

@Component({
  imports: [SafeUrl],
  selector: 'app-pdf-page',
  templateUrl: './pdf-page.component.html',
  styleUrl: './pdf-page.component.scss',
})
export class PdfPageComponent implements OnInit {

  public attachment: WritableSignal<string> = signal('');

  constructor(private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.attachment.set(params.get('attachment') || '');
    });
  }

}
